import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { AdminLocationAlertCreateModal } from "../../components/AdminLocationAlertsComponents/AdminLocationAlertCreateModal";
import { AdminLocationAlertsList } from "../../components/AdminLocationAlertsComponents/AdminLocationAlertsList";
import useAdminLocationAlerts from "../FacilityDetailsPage/hooks/useAdminLocationAlerts";

import "./styles.scss";

const AdminLocationAlertsPage: React.FC = () => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`adminLocationAlertsPage.${key}`);

  const [showCreateModal, setShowCreateModal] = useState(false);

  const { create } = useAdminLocationAlerts();

  const submit = async (data: any) => {
    try {
      await create(data);
      toast.success(t("success"));
      setShowCreateModal(false);
    } catch (error) {
      // Do nothing, axios will handle the error
    }
  };

  return (
    <>
      <div className="right-content admin-location-alerts">
        <div className="top-title-bar flex-grid">
          <div className="left-title">{t("title")}</div>
          <button
            className="btn btn-blue"
            onClick={() => {
              setShowCreateModal(true);
            }}
          >
            {t("add_alert")}
          </button>
          <div className="line"></div>
        </div>
        <div className="white-border-panel">
          <AdminLocationAlertsList />
        </div>
      </div>
      {showCreateModal && (
        <AdminLocationAlertCreateModal
          onClose={() => setShowCreateModal(false)}
          submit={submit}
        />
      )}
    </>
  );
};

export default AdminLocationAlertsPage;
